{
  "bookmarkTitleLabel": "书签",
  "debug": "调试",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "来自 Experience League 的结果",
  "feedback": "反馈",
  "fetchFailed": "获取失败",
  "help": "帮助",
  "helpDefaultFeatured": "Adobe Experience Cloud 学习和支持",
  "helpLoadError": "出现错误。请重试。",
  "noBookmarks": "为帮助内容添加书签以在此处访问",
  "noBookmarksTitle": "无书签",
  "noResults": "未找到结果",
  "noResultsMessage": "请检查拼写或尝试其他搜索词",
  "resourcesCustomerCareLabel": "客户关怀",
  "resourcesStatusLabel": "状态",
  "support": "支持"
}
